import type React from "react";
import {
  CalendarClock,
  CalendarDays,
  ClipboardIcon,
  CloudDownload,
  FolderClosedIcon,
  BookOpenText,
  MessageSquareDot,
  MessagesSquare,
  Factory,
  Landmark,
  HouseIcon,
} from "lucide-react";
import { Feature } from "@/types/user";
import { Link } from "react-router";
export interface NavigationItemLink {
  name: string;
  current: boolean;
  href?: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  children?: NavigationItem[];
  requiredFeature?: Feature;
  requiredFeatures?: Feature[];
  type: "item";
  tooltip?: React.ReactNode;
}
export type NavigationItem = NavigationItemLink | { type: "separator" };

export type NavigationMenuProps = NavigationItem[];

export const hasNavigationAccess = (item: NavigationItemLink, hasFeature: (feature: Feature) => boolean) =>
  (!item.requiredFeature || hasFeature(item.requiredFeature)) &&
  (!item.requiredFeatures || item.requiredFeatures.every(hasFeature));

export const NavigationSidebarItemsList: NavigationMenuProps = [
  { type: "item", requiredFeature: "open_chat", name: "Home", href: "/", icon: HouseIcon, current: false },
  { type: "item", name: "Documents", href: "/drive", icon: FolderClosedIcon, current: false },
  { type: "separator" },
  {
    type: "item",
    requiredFeature: "open_chat",
    name: "Open Chat",
    href: "/open-chat",
    icon: MessageSquareDot,
    current: false,
  },
  {
    type: "item",
    name: "SnapShot",
    href: "/snapshots",
    icon: ClipboardIcon,
    current: false,
    tooltip: (
      <div>
        <p className="text-md border-b-1 white mb-2 divide-white border-b pb-1">SnapShots</p>

        <Link className="mb-1 block text-sm" to="/snapshots/collections">
          Collections
        </Link>
        <Link className="mb-1 block text-sm" to="/snapshots/templates">
          Templates
        </Link>
        <Link className="block text-sm" to="/snapshots/recent">
          Recent SnapShots
        </Link>
      </div>
    ),
  },
  {
    type: "item",
    requiredFeature: "suppliers",
    name: "Suppliers",
    href: "/suppliers",
    icon: Factory,
    current: false,
  },
  {
    type: "item",
    requiredFeature: "spend_centre",
    requiredFeatures: ["suppliers"],
    name: "Spend Centre",
    href: "/spend-centre",
    icon: Landmark,
    current: false,
  },
  {
    type: "item",
    requiredFeature: "renewal_centre",
    requiredFeatures: ["suppliers"],
    name: "Renewal Centre",
    href: "/renewal-centre",
    icon: CalendarClock,
    current: false,
  },

  { type: "separator" },
  { type: "item", name: "Q&A History", href: "/recent-qa", icon: MessagesSquare, current: false },

  {
    type: "item",
    name: "Events Dashboard",
    href: "/snapshot-events",
    icon: CalendarDays,
    current: false,

    tooltip: (
      <div>
        <p className="text-md border-b-1 white mb-2 divide-white border-b pb-1">Events Dashboard</p>
        <Link className="mb-1 block text-sm" to="/snapshot-events/snapshotEvents">
          Snapshot Events
        </Link>
        <Link className="block text-sm" to="/snapshot-events/eventAnalytics">
          Analytics
        </Link>
      </div>
    ),
  },
  { type: "item", name: "Prompt Library", href: "/prompt-library", icon: BookOpenText, current: false },
  {
    type: "item",
    requiredFeature: "sharepoint",
    name: "Sharepoint",
    href: "/sharepoint",
    icon: CloudDownload,
    current: false,
  },
];
